var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"temporary"},[_c('a-spin',{attrs:{"spinning":_vm.spinnings,"tip":_vm.message}},[_c('div',{staticClass:"d-flex flex-column min-vh-100"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }